<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title>
          {{ t('RegisterPage.registerAccount') }}
        </ion-title>
        <ion-buttons slot="start">
          <ion-back-button default-href="/login"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content :fullscreen="true">
      <ion-grid>
        <ion-row class="ion-justify-content-center">
          <ion-col size="12" size-md="8" size-lg="6" size-xl="4">
            <ion-card class="ion-text-center">
              <ion-card-header>
                <logo-img :withText="true"></logo-img>
              </ion-card-header>
              <ion-card-content>
                <ion-item>
                  <ion-label position="floating">{{ t('RegisterPage.loginEmail') }}</ion-label>
                  <ion-input inputmode="email" type="text" v-model="newUser.loginEmail"></ion-input>
                </ion-item>
                <ion-item>
                  <ion-label position="floating">{{ t('RegisterPage.password') }}</ion-label>
                  <ion-input type="password" v-model="newUser.loginPsw"></ion-input>
                </ion-item>
                <ion-item>
                  <ion-label position="floating">{{ t('RegisterPage.confirmPassword') }}</ion-label>
                  <ion-input type="password" v-model="newUser.confirmLoginPsw" @keyup.enter="doRegister()"></ion-input>
                </ion-item>
                <ion-button class="submit-btn" expand="block" @click="doRegister(loginEmail, loginPsw, confirmLoginPsw)">
                  {{ t('RegisterPage.register') }}
                </ion-button>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { reactive } from 'vue';

// icons
import { mail, key, } from 'ionicons/icons';

// components
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
        IonGrid, IonCol, IonRow, IonButtons, IonButton, IonBackButton, IonIcon,
        IonCard, IonCardHeader, IonCardContent, IonItem, IonLabel, IonInput,
        loadingController, } from '@ionic/vue';
import LogoImg from '@/components/LogoImg.vue';

// composables
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { utils } from '@/composables/utils';

// services
import AuthService from '@/services/AuthService';

export default {
  name: 'RegisterPage',
  components: { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
                IonGrid, IonCol, IonRow, IonButtons, IonButton, IonBackButton, IonIcon,
                IonCard, IonCardHeader, IonCardContent, IonItem, IonLabel, IonInput, LogoImg, },
  setup() {
    const newUser = reactive({
      loginEmail: "",
      loginPsw: "",
      confirmLoginPsw: "",
    });

    // methods
    const store = useStore();
    const { t } = useI18n();
    const { presentAlert } = utils();

    const doRegister = async () => {
      const { loginEmail, loginPsw, confirmLoginPsw } = newUser;
      if (loginEmail && loginPsw && confirmLoginPsw) {
        if (loginPsw == confirmLoginPsw) {
          const loading = await loadingController.create({});
          await loading.present();
          try {
            const res = await AuthService.doRegister(loginEmail, loginPsw);
            store.dispatch('createNewUser', { uid: res.user?.uid, ...newUser, });
          } catch (e) {
            presentAlert(e.message, t('errorHeader')); // wrong email or wrong password
          }
          loading.dismiss();
        } else {
          // password not match
          presentAlert( t('inconsistentPasswordMsg'), t('errorHeader') );
        }
      } else {
        presentAlert( t('RegisterPage.enterEmailAndPassword'), t('errorHeader') );
      }
    };
    
    return {
      t,

      // icons
      mail, key,

      // variables
      newUser,

      // methods
      doRegister,
    }
  },
}
</script>

<style scoped>
  .text-btn {
    cursor: pointer;
  }
  ion-grid {
    height: 100%;
  }
  ion-row {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
</style>